export const REDUX_GET_TIMETABLE_CATEGORIES = 'REDUX_GET_TIMETABLE_CATEGORIES'
export const REDUX_GET_TIMETABLE_SUBCATEGORIES = 'REDUX_GET_TIMETABLE_SUBCATEGORIES'
export const REDUX_GET_TIMETABLE_SUBCATEGORY_BY_ID = 'REDUX_GET_TIMETABLE_SUBCATEGORY_BY_ID'
export const REDUX_GET_ALL_CONSTRAINTS = 'REDUX_GET_ALL_CONSTRAINTS'
export const REDUX_GET_CONSTRAINT_BY_ID = 'REDUX_GET_CONSTRAINT_BY_ID'
export const REDUX_UPDATE_CONSTRAINT = 'REDUX_UPDATE_CONSTRAINT'
export const REDUX_GET_TIMETABLE = 'REDUX_GET_TIMETABLE'
export const REDUX_GET_TIMETABLE_LIST_DATA = 'REDUX_GET_TIMETABLE_LIST_DATA'
export const REDUX_GET_TIMETABLE_REPORT = 'REDUX_GET_TIMETABLE_REPORT'
export const REDUX_SET_SELECTED_BRANCH_ID = 'REDUX_SET_SELECTED_BRANCH_ID'
export const REDUX_SET_SELECTED_LEVEL_ID = 'REDUX_SET_SELECTED_LEVEL_ID'
export const REDUX_SET_SELECTED_DURATION_ID = 'REDUX_SET_SELECTED_DURATION_ID'
export const REDUX_SET_SELECTED_VERSION_ID = 'REDUX_SET_SELECTED_VERSION_ID'
// Local UI counters for preference_count and change notifications
export const REDUX_INCREMENT_CATEGORY_PREFERENCE_COUNT = 'REDUX_INCREMENT_CATEGORY_PREFERENCE_COUNT'
export const REDUX_INCREMENT_SUBCATEGORY_PREFERENCE_COUNT =
  'REDUX_INCREMENT_SUBCATEGORY_PREFERENCE_COUNT'
export const REDUX_DECREMENT_CATEGORY_PREFERENCE_COUNT = 'REDUX_DECREMENT_CATEGORY_PREFERENCE_COUNT'
export const REDUX_DECREMENT_SUBCATEGORY_PREFERENCE_COUNT =
  'REDUX_DECREMENT_SUBCATEGORY_PREFERENCE_COUNT'
export const REDUX_CONSTRAINTS_UPDATED_TICK = 'REDUX_CONSTRAINTS_UPDATED_TICK'
